export default "/_next/static/images/service-recurring-2x-afae736727c5c9c4117b07345ba5bb96.png";